var _Desktop, _Tablet, _Mobile;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Spacing } from '@doordash/design-language';
export var Sizes = {
  Custom: 'MODAL/CUSTOM',
  FullScreen: 'MODAL/FULL_SCREEN',
  XxLarge: 'MODAL/XX_LARGE',
  XLarge: 'MODAL/X_LARGE',
  Large: 'MODAL/LARGE',
  Medium: 'MODAL/MEDIUM',
  Small: 'MODAL/SMALL'
};
export var CloseButtonSides = {
  Leading: 'Leading',
  Trailing: 'Trailing'
};
export var BreakpointModalWidths = {
  Desktop: (_Desktop = {}, _defineProperty(_Desktop, Sizes.Small, 480), _defineProperty(_Desktop, Sizes.Medium, 480), _defineProperty(_Desktop, Sizes.Large, 560), _defineProperty(_Desktop, Sizes.XLarge, 768), _defineProperty(_Desktop, Sizes.XxLarge, 1024), _Desktop),
  Tablet: (_Tablet = {}, _defineProperty(_Tablet, Sizes.Small, 480), _defineProperty(_Tablet, Sizes.Medium, 480), _defineProperty(_Tablet, Sizes.Large, 560), _defineProperty(_Tablet, Sizes.XLarge, 768), _defineProperty(_Tablet, Sizes.XxLarge, 768), _Tablet),
  Mobile: (_Mobile = {}, _defineProperty(_Mobile, Sizes.Small, 480), _defineProperty(_Mobile, Sizes.Medium, 480), _defineProperty(_Mobile, Sizes.Large, 480), _defineProperty(_Mobile, Sizes.XLarge, 480), _defineProperty(_Mobile, Sizes.XxLarge, 480), _Mobile)
}; // TODO: deprecate and remove in v7, now theme-based

export var ContentPadding = {
  Desktop: Spacing.XLarge,
  Tablet: Spacing.Large,
  Mobile: Spacing.Small
};